import React, { useState, useEffect, useRef } from "react";
import Button from "../Button";
import styles from "./SuccessDialog.css";

const SuccessDialog = ({ orderNo, dispatch }) => {
    const ref = useRef();

    useEffect(() => {
        if (open && !ref.current.open) {
            ref.current.showModal();
        }
    }, []);

    return (
        <dialog ref={ref} className={styles.Dialog}>
            <div className={styles.DialogContainer}>
                <header className={styles.Header}>
                    <h1 className={styles.Title}>
                        Buchung erfolgreich eingegangen.
                    </h1>

                    <p>
                        Sie erhalten in Kürze eine Bestätigung per E-Mail. <br />
                        Ihre Anmeldung führen wir unter {orderNo}.
                    </p>
                    <p>Sie können dieses Fenster schließen</p>
                </header>
            </div>
        </dialog>
    );
};

export default SuccessDialog;
